import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import FotaWebSmallLogoIcon from "assets/customIcons/logos/FotaWebSmallLogoIcon";

const AuthLoader = () => {
    const { white } = colors;

    return (
        <div
            css={css({
                position: "absolute",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: white,
                zIndex: "9999"
            })}
        >
            <FotaWebSmallLogoIcon
                css={css({
                    fontSize: "32px",
                    animationName: "pulse",
                    animationDuration: "1.5s",
                    animationTimingFunction: "linear",
                    animationIterationCount: "infinite",
                    animationDirection: "alternate",

                    "@keyframes pulse": {
                        from: {
                            transform: "scale(1)"
                        },
                        to: {
                            transform: "scale(1.3)"
                        }
                    }
                })}
            />
        </div>
    );
};

export default AuthLoader;
